<template>
  <div class="bg app" id="gwi-index">
    <div class="body">
      <health-card-swiper :healthCardList="healthCardList" />
      <div class="module banner">
        <icon-menu name="register">
          <img src="../../../static/img/home/banner2.png" />
        </icon-menu>
        <icon-menu name="pay" style="text-align: right">
          <img src="../../../static/img/home/banner1.png" />
        </icon-menu>
      </div>
      <div class="module channel">
        <icon-menu v-if="channel !== 'TFY' && channel !== 'TFTB' && channel !== 'TFRYB'" name="outregister">
          <div>市外挂号</div>
        </icon-menu>
        <icon-menu name="myregister">
          <div>挂号记录</div>
        </icon-menu>
        <icon-menu name="mypay">
          <div>缴费记录</div>
        </icon-menu>
        <icon-menu name="myreport">
          <div>查询报告</div>
        </icon-menu>
      </div>
      <div class="module menu">
        <icon-menu name="residentHealthRecord">
          <p>健康档案</p>
        </icon-menu>
        <icon-menu name="MyPrescription">
          <p>电子处方</p>
        </icon-menu>
        <icon-menu name="InpatientRegister">
          <p>住院登记</p>
        </icon-menu>
        <icon-menu name="waitDoctor">
          <p>排队候诊</p>
        </icon-menu>
        <icon-menu name="healthRecord">
          <p>健康证申领</p>
        </icon-menu>
        <icon-menu name="inMap">
          <p>院内导航</p>
        </icon-menu>
        <icon-menu name="inpatientprepay">
          <p>住院预缴</p>
        </icon-menu>
        <icon-menu name="HospitalCostList">
          <p>住院费用查询</p>
        </icon-menu>
        <icon-menu name="hosinfo">
          <p>医院介绍</p>
        </icon-menu>
        <icon-menu name="bedsinfo">
          <p>床位查询</p>
        </icon-menu>
        <icon-menu name="familyDoctor">
          <p>家医签约</p>
        </icon-menu>
        <icon-menu name="selfHealthAssessment">
          <p>健康评估</p>
        </icon-menu>
        <icon-menu name="emergencyCall">
          <p>急救呼叫</p>
        </icon-menu>
        <icon-menu name="heathGuide">
          <p>健康指导</p>
        </icon-menu>
<!--        <icon-menu-->
<!--          name="healthAdvice"-->
<!--          @showHealthAdvice="showHealthAdvice = true"-->
<!--        >-->
<!--          <p>健康咨询</p>-->
<!--        </icon-menu>-->

<!--          <icon-menu name="littleAssistant" style="padding: 0">-->
<!--            <wx-open-launch-weapp-->
<!--                id="launch-btn"-->
<!--                :username="username"-->
<!--                :appid="appid"-->
<!--                :path="path"-->
<!--            >-->
<!--              <script type="text/wxtag-template">-->
<!--                <style>-->
<!--                  .btn_go{-->
<!--                    background: none;-->
<!--                    border: none;-->
<!--                    color: #333;-->
<!--                    padding:47px 0 0 0;-->
<!--                  }-->
<!--                </style>-->
<!--                <button class="btn_go">AI健康小助手</button>-->
<!--              </script>-->
<!--            </wx-open-launch-weapp>-->
<!--          </icon-menu>-->

        <!-- 小程序菜单 -->
        <applet-icon-menu
            name="AI健康小助手"
            appid="wx4616f848767a6431"
            :icon-src="require('../../../static/img/home/menu16.png')"
            user-name="gh_10015f7c55a5"
            path="pages/home/index"
        >
        </applet-icon-menu>
        <icon-menu name="internetHospital">
          <p>互联网医院</p>
        </icon-menu>
        <icon-menu name="SurveyList">
          <p>满意度评价</p>
        </icon-menu>
      </div>
    </div>

    <div class="healthAdviceTip" v-show="showHealthAdvice">
      <div class="content">
        <p>
          1.专家提示：在线咨询不能取代线下面诊，如出现发热、乏力、咳嗽、呼吸困难等呼吸道症状，请戴上口罩立即前往就近定点医院就医。
        </p>
        <p class="mt10">
          2.您好！请将您的问题，在【健康彭州就医通】微信公众号对话框中编辑好，发送给我们，我们会尽快回复您！
        </p>
        <button class="btn" @click="showHealthAdvice = false">确定</button>
      </div>
    </div>
  </div>
</template>
<script>
import voucherService from 'voucher.service'
import tfyService from 'tfy.service'
import Qrcode from 'v-qrcode'
import Swipe from 'Swipe'
import IconMenu from 'Menu'
import AppletIconMenu from 'AppletIconMenu'
import basicsMixinx from 'mixins/basics'
import HealthCardSwiper from 'health-card-swiper/swiper'

export default {
  mixins:[basicsMixinx],
  components: {
    Swipe,
    IconMenu,
    AppletIconMenu,
    Qrcode,
    HealthCardSwiper
  },
  data () {
    return {
      showHealthAdvice: false,
      channel: localStorage.channel,
      healthCardList: [],
      username:"gh_10015f7c55a5",
      appid:"wx4616f848767a6431",
      path:"pages/home/index"
    }
  },

  /*eslint-disable*/
  created () {
    // eruda.init();
    //获取当前的channel
    var ua = navigator.userAgent.toLowerCase();
    console.log('ua = ', ua);
    if (ua.match(/MicroMessenger/i) == "micromessenger" || process.env.NODE_ENV === "development") {
      console.log('这是从健康彭州微信公众号进来的')
      localStorage.setItem('channel', 'WX');
      //判断是否存在tokenId,且当前界面code失效
      const query = this.$router.currentRoute.query
      const code = query.code
      if (code) {
        var getTokenParams = { code: code }
        voucherService.getToken(getTokenParams).then((res) => {
          if (res.resultCode !== this.constant.RESULT_SUCCESS) {
            //失败以后，直接使用本地token调用后续接口
            this.loadHome();
            return
          }

          //缓存最新code给后台
          localStorage.setItem('deviceId', code);
          sessionStorage.setItem('deviceId', code);

          //返回新token保存本地使用
          localStorage.tokenId = res.data.tokenId;
          localStorage.setItem('tokenId', res.data.tokenId);
          sessionStorage.setItem('tokenId', res.data.tokenId);
          window.http.headers.common['tokenId'] = localStorage.tokenId || ''
          window.http.headers.common['channel'] = localStorage.channel

          //  查询是否绑卡
          this.loadHome();
        })
      } else {
        //  查询是否已经获取到token
        if (!localStorage.tokenId && !sessionStorage.tokenId) {
          return this.$utils.alert('用户登录失效，请重新使用手机号登录')
        }
        this.loadHome();
      }
    } else {
      if(ua.indexOf("tftb_hanweb") > -1) {
        console.log('这是从天府通办进来的')
        // 天府通办APP进来的
        localStorage.setItem('channel', 'TFTB');
        window.http.headers.common['channel'] = localStorage.channel
        this.loadTFUserInfo()
        return
      }
      if(ua.indexOf("tfryb_hanweb") > -1) {
        console.log('这是从天府蓉易办进来的')
        // 天府蓉易办APP进来的
        localStorage.setItem('channel', 'TFRYB');
        window.http.headers.common['channel'] = localStorage.channel
        this.loadTFUserInfo()
        return
      }
      console.log('这是从天府市民云进来的')
      // 天府市民云APP进来的
      localStorage.setItem('channel', 'TFY');
      //获取天府云token
      var query = this.$router.currentRoute.query;
      console.log(!query.token && !localStorage.tokenId)
      console.log(!query.token)
      console.log(!localStorage.tokenId)
      if (!query.token && !localStorage.tokenId) {
        return this.$utils.alert('用户登录失效，请重新使用天府云登录')
      }
      localStorage.setItem('tokenId', query.token ? query.token : localStorage.tokenId);
      window.http.headers.common['tokenId'] = localStorage.tokenId || ''
      window.http.headers.common['channel'] = localStorage.channel
      this.loadHome();
    }
  },
  methods: {
    loadTFUserInfo() {
      // if(localStorage.tokenId && localStorage.tokenId !== 'undefined') {
      //   console.log('已经获取过天府通办用户信息，tokenId = ', localStorage.tokenId)
      //   window.http.headers.common['tokenId'] = localStorage.tokenId || ''
      //   this.loadHome()
      //   return
      // }
      console.log('开始获取天府通办用户信息')
      const that = this
      JmasJssdk.user.getUserInfo({
        success: (data) => {
          console.log('获取天府通办用户信息成功,data = ', data)
          if(data.code !== 200 || !data.data) {
            that.$utils.alert('获取天府用户信息失败')
            return
          }
          const resData = JSON.parse(data.data)
          if(!resData || !resData.data) {
            that.$utils.alert('获取天府用户信息失败')
            return
          }
          const resUserInfo = resData.data
          console.log('resUserInfo = ', resUserInfo)
          const real = resUserInfo.real
          console.log('real = ', real)
          const base = resUserInfo.base
          console.log('base = ', base)
          real.employeeMobile = base.employeeMobile
          real.channel = localStorage.channel
          console.log('loginByRybUser 入参 = ', real)
          tfyService.loginByRybUser(real).then((res)=> {
            localStorage.setItem('tokenId', res.data.tokenId);
            window.http.headers.common['tokenId'] = localStorage.tokenId || ''
            console.log('loginByRybUser loadHome')
            that.loadHome();
          })
        },
        fail: (err) => {
          that.$utils.alert('获取天府用户信息失败')
          console.log('获取天府通办用户信息失败,err = ', err)
        }
      })
    },
    loadHome () {
      // 首页始终显示banner图片，不需要再查询是否有就诊凭证
      voucherService.getVoucherList().then((res) => {
        if (res.resultCode == this.constant.RESULT_SUCCESS) {
          if (res.data.length > 0) {
            this.healthCardList = res.data
          } else {
            this.healthCardList = []
          }
        }
      })

      const payResultStr = localStorage.getItem('payResult')
      if (payResultStr) {
        const payResult = JSON.parse(payResultStr)
        if (payResult.result) {
          if (payResult.busiType === this.constant.BUSI_TYPE.OUT_PATIENT_PAYMENT) {
            this.$router.push('mypay')
          } else if (payResult.busiType === this.constant.BUSI_TYPE.REGISTRATION_PAYMENT) {
            //挂号缴费
            //this.$store.commit('updateParam', {
            //namespace: 'regDetail',
            //isPaySuccess: true
            //})
            //this.$router.push('regdetail')
            this.$router.push('myregister')
          }
        } else {
          //支付失败
          if (payResult.busiType === this.constant.BUSI_TYPE.OUT_PATIENT_PAYMENT) {
            //跳转门诊缴费列表
            this.$router.push('clinicUnpayList')
          } else if (payResult.busiType === this.constant.BUSI_TYPE.REGISTRATION_PAYMENT) {
            //跳转我的挂号列表
            this.$router.push('myregister')
          }
        }
        localStorage.removeItem('payResult')
      } else {
        this.$store.commit('clearParam', 'all')
      }
    },
    goProfile () {
      this.$router.push('profile')
    },
    goAddVoucher () {
      this.$router.push({
        path: 'voucherChooseType'
      });
    },
    selectVoucher (voucher) {
      this.$store.commit('updateParam', {
        namespace: 'detail',
        voucher: voucher
      });
      this.$router.push('voucherDetail');
    },
  }
}
</script>
<style lang="scss" scoped >

.bg {
  background: #eef2f5 url(../../../static/img/home/bg.png) center top no-repeat;
  background-size: 100% auto;
  box-sizing: border-box;
}
.body {
  position: absolute;
  left: 0;
  right: 0;
  top: 50px;
  bottom: 63px;
  padding: 0 10px;
  overflow-y: auto;
}
.module {
  background: white;
  padding: 10px;
  border-radius: 10px;
  margin-top: 10px;
  font-size: 13px;
}
.banner {
  display: flex;
  justify-content: space-between;
  padding: 10px 5px;
  .menuIcon {
    width: 50%;
  }
  img {
    width: 100%;
    padding: 0 5px;
    display: block;
    box-sizing: border-box;
  }
}

.channel {
  display: flex;
  justify-content: space-between;
  padding: 10px 20px;
  .menuIcon {
    padding-top: 54px;
    background-size: 100% auto;
    background-position: top center;
    background-repeat: no-repeat;
    font-size: 13px;
    line-height: 22px;
    font-weight: bold;

  }
  .outregister {
    background-image: url(../../../static/img/home/channel1.png);
  }
  .myregister {
    background-image: url(../../../static/img/home/channel2.png);
  }
  .mypay {
    background-image: url(../../../static/img/home/channel3.png);
  }
  .myreport {
    background-image: url(../../../static/img/home/channel4.png);
  }
}

.menu {
  display: flex;
  flex-wrap: wrap;
  padding: 0 10px 20px 10px;
  margin-bottom: 10px;
  .menuIcon {
    padding-top: 40px;
    background-size: auto 50%;
    background-position: top center;
    background-repeat: no-repeat;
    font-size: 13px;
    line-height: 22px;
    width: 25%;
    text-align: center;
    margin-top: 20px;
    position: relative;
  }
  .residentHealthRecord {
    background-image: url(../../../static/img/home/menu1.png);
  }
  .waitDoctor {
    background-image: url(../../../static/img/home/menu4.png);
  }

  .inpatientprepay {
    background-image: url(../../../static/img/home/menu7.png);
  }
  .familyDoctor {
    background-image: url(../../../static/img/home/menu10.png);
  }
  .heathBasicInformation {
    background-image: url(../../../static/img/home/menu15.png);
  }
  .MyPrescription {
    background-image: url(../../../static/img/home/menu2.png);
  }
  .healthRecord {
    background-image: url(../../../static/img/home/menu5.png);
  }
  .hosinfo {
    background-image: url(../../../static/img/home/menu8.png);
  }
  .selfHealthAssessment {
    background-image: url(../../../static/img/home/menu11.png);
  }
  .InpatientRegister {
    background-image: url(../../../static/img/home/menu3.png);
  }
  .inMap {
    background-image: url(../../../static/img/home/menu6.png);
  }
  .bedsinfo {
    background-image: url(../../../static/img/home/menu9.png);
  }
  .emergencyCall {
    background-image: url(../../../static/img/home/menu12.png);
  }
  .heathGuide {
    background-image: url(../../../static/img/home/menu13.png);
  }
  .MeterBooking {
    background-image: url(../../../static/img/home/menu14.png);
  }
  .HealthInfo {
    background-image: url(../../../static/img/home/menu15.png);
  }
  .healthAdvice {
    background-image: url(../../../static/img/home/menu16.png);
  }
  .HospitalCostList {
    background-image: url(../../../static/img/home/menu9.png);
  }
  .littleAssistant {
    background-image: url(../../../static/img/home/menu16.png);
  }
  .internetHospital {
    background-image: url(../../../static/img/home/menu8.png);
  }
  .SurveyList {
    background-image: url(../../../static/img/home/menu11.png);
  }
}
.healthAdviceTip {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 9999;
  background: #efefef;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.5);

  .content {
    background: #fff;
    width: 280px;
    border: 1px solid #efefef;
    border-radius: 10px;
    padding: 20px;
  }
  p {
    line-height: 28px;
  }
  .mt10 {
    margin-top: 10px;
  }
  .btn {
    width: 140px;
    height: 35px;
    text-align: center;
    display: block;
    margin: 20px auto 0 auto;
    border-radius: 10px;
    color: white;
    font-size: 16px;
    background: #25be98;
  }
}
</style>



// WEBPACK FOOTER //
// Home.vue?6e245dc3